export const areNotificationsEnabled = () => {
    if (Notification.permission === 'granted') {
        return true;
    }

    else {
        return false;
    };
};